import { render, staticRenderFns } from "./ReasonPoint.vue?vue&type=template&id=69814d31&scoped=true&"
import script from "./ReasonPoint.vue?vue&type=script&lang=js&"
export * from "./ReasonPoint.vue?vue&type=script&lang=js&"
import style0 from "./ReasonPoint.vue?vue&type=style&index=0&id=69814d31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69814d31",
  null
  
)

export default component.exports